import { useEffect } from "react";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./components/layout/sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import Dashboard from "./components/pages/dashboard/Dashboard";
import Assessment from "./components/pages/assessment/Assessment";
import AccessManagement from "./components/pages/access-management/AccessManagement";
import NewSet from "./components/pages/assessment/new-set/NewSet";
import SurveyCreation from "./components/pages/survey-creation/SurveyCreation";
import ProtectedRoute from "./components/protected-route/ProtectedRoute";
import CreateQuestion from "./components/pages/assessment/new-set/create-question/CreateQuestion";
import SurveySubmission from "./components/pages/survey-submission/survey-submission";
import ApprovalScreen from "./components/pages/assessment/approval-screen/approval-screen";
import Otp from "./components/pages/survey-submission/Otp/otp";
import SurveyDetails from "./components/pages/dashboard/SurveyDetails";
import Home from "./components/pages/home/Home";
import Login from "./components/pages/login/Login";
import AccessError from "./components/layout/access-error/AccessError";
import { checkTokenExpiry } from "./database";
import "@fortawesome/fontawesome-free/css/all.min.css";


const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const SESSION_TIMEOUT = 10 * 60 * 1000;

  const showSidebar = sessionStorage.getItem("key");

  const hideSidebar = ["/otp", "/survey"];
  const displaySidebar = !hideSidebar.includes(location.pathname);


  // const path = location.pathname;


  useEffect(() => {
    if (!sessionStorage.getItem("Product_ACCESS_TOKEN")) {
      if (!window.location.href.split("=")[1]) navigate("/login");
    }
  }, []);

  useEffect(() => {
    let timeout: any;

    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        logoutUser();
      }, SESSION_TIMEOUT);
    };

    const logoutUser = () => {
      sessionStorage.clear();
      window.location.assign(`${process.env.REACT_APP_COGNITOSSO_LOGOUT_URL}`);
    };

    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keydown", resetTimeout);
    window.addEventListener("click", resetTimeout);

    resetTimeout();

    return () => {
      clearTimeout(timeout);

      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keydown", resetTimeout);
      window.removeEventListener("click", resetTimeout);
    };
  }, []);

  setInterval(checkTokenExpiry, 60 * 1000);
  return (
    <div className="app">
      {displaySidebar && <Sidebar />}
      <Routes>
      <Route path="/" element={<Home/>} />

        <Route element={<ProtectedRoute requiredPermission="dashboard" />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>


        <Route element={<ProtectedRoute requiredPermission="survey" />}>
        <Route path="/survey-details" element={<SurveyDetails />} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="assessment" />}>
        <Route path="/assessment" element={<Assessment />} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="assessment" />}>
        <Route path="/assessment/new-set" element={<NewSet />} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="access" />}>
        <Route path="/access-management" element={<AccessManagement />} />
        </Route>

        <Route element={<ProtectedRoute requiredPermission="survey" />}>
        <Route path="/survey-creation" element={<SurveyCreation />} />
        </Route>

        <Route path="/login" element={<Login />} />
        <Route path="/Unauthorised" element={<AccessError />} />


        <Route element={<ProtectedRoute requiredPermission="assessment" />}>
        <Route
          path="/assessment/new-set/question"
          element={<CreateQuestion />}
        />        
        </Route>
        
         <Route path="/approval-screen" element={<ApprovalScreen />} />

         {/* <Route element={<ProtectedRoute requiredPermission="otp" />}> */}
         <Route path="/otp" element={<Otp />} />
        {/* </Route> */}


         {/* <Route element={<ProtectedRoute requiredPermission="survey" />}> */}
         <Route path="/survey" element={<SurveySubmission />} />
        {/* </Route> */}

      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="colored"
      />
    </div>
  );
};

export default App;

// import { useEffect } from "react";
// import "./App.scss";
// import "react-toastify/dist/ReactToastify.css";
// import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import Sidebar from "./components/layout/sidebar/Sidebar";
// import { useDispatch } from "react-redux";
// import { ToastContainer } from "react-toastify";
// import Dashboard from "./components/pages/dashboard/Dashboard";
// import Assessment from "./components/pages/assessment/Assessment";
// import AccessManagement from "./components/pages/access-management/AccessManagement";
// import NewSet from "./components/pages/assessment/new-set/NewSet";
// import SurveyCreation from "./components/pages/survey-creation/SurveyCreation";
// import ProtectedRoute from "./components/protected-route/ProtectedRoute";
// import CreateQuestion from "./components/pages/assessment/new-set/create-question/CreateQuestion";
// import SurveySubmission from "./components/pages/survey-submission/survey-submission";
// import ApprovalScreen from "./components/pages/assessment/approval-screen/approval-screen";
// import Otp from "./components/pages/survey-submission/Otp/otp";
// import SurveyDetails from "./components/pages/dashboard/SurveyDetails";
// import Home from "./components/pages/home/Home";
// import Login from "./components/pages/login/Login";
// import AccessError from "./components/layout/access-error/AccessError";
// import { checkTokenExpiry } from "./database";

// const App = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const SESSION_TIMEOUT = 10 * 60 * 1000;

//   const showSidebar = sessionStorage.getItem("key");

//   const hideSidebar = ["/otp", "/survey"];
//   const displaySidebar = !hideSidebar.some((path) => location.pathname.startsWith(path));

//   useEffect(() => {
//     if (!sessionStorage.getItem("Product_ACCESS_TOKEN")) {
//       if (!window.location.href.split("=")[1]) navigate("/login");
//     }
//   }, []);

//   useEffect(() => {
//     let timeout: any

//     const resetTimeout = () => {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => {
//         logoutUser();
//       }, SESSION_TIMEOUT);
//     };

//     const logoutUser = () => {
//       sessionStorage.clear();
//       window.location.assign(`${process.env.REACT_APP_COGNITOSSO_LOGOUT_URL}`);
//     };

//     window.addEventListener("mousemove", resetTimeout);
//     window.addEventListener("keydown", resetTimeout);
//     window.addEventListener("click", resetTimeout);

//     resetTimeout();

//     return () => {
//       clearTimeout(timeout);

//       window.removeEventListener("mousemove", resetTimeout);
//       window.removeEventListener("keydown", resetTimeout);
//       window.removeEventListener("click", resetTimeout);
//     };
//   }, []);

//   setInterval(checkTokenExpiry, 60 * 1000);

//   return (
//     <div className="app">
//       {displaySidebar && <Sidebar />}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route element={<ProtectedRoute requiredPermission="dashboard" />}>
//           <Route path="/dashboard" element={<Dashboard />} />
//         </Route>
//         <Route element={<ProtectedRoute requiredPermission="survey" />}>
//           <Route path="/survey-details" element={<SurveyDetails />} />
//         </Route>
//         <Route element={<ProtectedRoute requiredPermission="assessment" />}>
//           <Route path="/assessment" element={<Assessment />} />
//         </Route>
//         <Route element={<ProtectedRoute requiredPermission="assessment" />}>
//           <Route path="/assessment/new-set" element={<NewSet />} />
//         </Route>
//         <Route element={<ProtectedRoute requiredPermission="access" />}>
//           <Route path="/access-management" element={<AccessManagement />} />
//         </Route>
//         <Route element={<ProtectedRoute requiredPermission="survey" />}>
//           <Route path="/survey-creation" element={<SurveyCreation />} />
//         </Route>
//         <Route path="/login" element={<Login />} />
//         <Route path="/Unauthorised" element={<AccessError />} />
//         <Route element={<ProtectedRoute requiredPermission="assessment" />}>
//           <Route path="/assessment/new-set/question" element={<CreateQuestion />} />
//         </Route>
//         <Route path="/approval-screen" element={<ApprovalScreen />} />
//         <Route path="/otp" element={<Otp />} />
//         <Route path="/survey" element={<SurveySubmission />} />
//       </Routes>
//       <ToastContainer
//         position="top-center"
//         autoClose={2000}
//         hideProgressBar={true}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover={false}
//         theme="colored"
//       />
//     </div>
//   );
// };

// export default App;
